import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { ContentService } from 'src/app/services/content.service';
import { StateService } from 'src/app/services/state.service';
import { ConfigService } from 'src/app/services/config.service';
import { LangService } from 'src/app/services/lang.service';
import { environment } from 'src/environments/environment';
import { EncryptionService } from 'src/app/services/encryption.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule
    ]
})
export class FooterComponent implements OnInit {

  public logoFooter: string = ''
  public lang : string
  public privateMode: boolean = false
  public environment = environment
  public isProfileLinksOpen: boolean = false

  toggleProfileLinks(): void {
    this.isProfileLinksOpen = !this.isProfileLinksOpen;
  }

  constructor(private contentService: ContentService,
                private stateService: StateService,
                public configService: ConfigService,
                private langService: LangService,
                public router: Router,
                private encryptionService: EncryptionService) 
  { 
    this.lang = langService.getLanguage()!
  }

  ngOnInit(): void {

    //Suscripción al observable 'NavbarPrivateObservable' que informa cada componente del router indicando si debe mostrar
    //cabecera private o pública.
    this.stateService.NavbarPrivateObservable
    .subscribe({
        next: (data) => {
          this.privateMode = data

          if(this.privateMode){

            this.contentService.getPrivateContent().subscribe((data) => {
              const found = data.find((obj: { content: { location: { id: any; }; }; }) => obj.content.location.id === this.configService.companyConfig.logo.footer);
              this.logoFooter = found?.content?.images?.[this.lang]?.web?.[0]?.url || environment.imagePath + '/shared/logos/logo-text-white.png';
            });
            
          }else{

            this.contentService.getPublicContent().subscribe((data) => {
              const found = data.find((obj: { content: { location: { id: any; }; }; }) => obj.content.location.id === this.configService.companyConfig.logo.footer);
              this.logoFooter = found?.content?.images?.[this.lang]?.web?.[0]?.url || environment.imagePath + '/shared/logos/logo-text-white.png';
            });
          }
        },
        error: (error) => {}
    })
  }

}
